import { Logger } from "lib/logger"
import React from "react"
import { withErrorBoundary } from "react-error-boundary"
import type { Maybe, PlpRelatedCategoryType } from "types"
import {
  categoryLink,
  categoryText,
  container,
  wrapper,
} from "./relatedCategories.css"

type Props = {
  categories?: Maybe<Array<PlpRelatedCategoryType>>
  id: "plp_category_links"
}

const RelatedCategoriesComponent: React.FC<Props> = ({ categories, id }) => {
  return (
    <div className={wrapper}>
      <div id={id} className={container}>
        {categories?.map((category, index) => {
          const categoryUrl = category?.href ? `${category.href}` : ""
          const key = `${id}-${category?.title}${index}`
          return (
            <a
              className={categoryLink}
              key={key}
              href={categoryUrl}
              id={id}
              data-track-click={id}
            >
              <span className={categoryText}>{category?.title}</span>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export const RelatedCategoriesV2 = withErrorBoundary(
  RelatedCategoriesComponent,
  {
    fallback: <div />,
    onError(error) {
      Logger.warn(`Related categories failed to load. ${error}`)
    },
  }
)
